'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var fails$8 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$7 = fails$8;
var classof = classofRaw;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$7(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$4 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$c =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var shared$2 = {exports: {}};

var fails$6 = fails$8;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails$6(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectDefineProperty = {};

var isObject$5 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var global$b = global$c;
var isObject$4 = isObject$5;

var document$1 = global$b.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

var DESCRIPTORS$5 = descriptors;
var fails$5 = fails$8;
var createElement = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$5 && !fails$5(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var isObject$3 = isObject$5;

var anObject$7 = function (it) {
  if (!isObject$3(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var isObject$2 = isObject$5;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$2(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$2(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$2(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$2(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var anObject$6 = anObject$7;
var toPrimitive$1 = toPrimitive$2;

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject$6(O);
  P = toPrimitive$1(P, true);
  anObject$6(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;

var createNonEnumerableProperty$7 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var global$a = global$c;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$7;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$6(global$a, key, value);
  } catch (error) {
    global$a[key] = value;
  } return value;
};

var global$9 = global$c;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$9[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$2.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var hasOwnProperty = {}.hasOwnProperty;

var has$9 = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var fails$4 = fails$8;

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$4(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var global$8 = global$c;
var shared$1 = shared$2.exports;
var has$8 = has$9;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$1('wks');
var Symbol$1 = global$8.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$5 = function (name) {
  if (!has$8(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has$8(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$3 = toIndexedObject$4;
var toLength = toLength$1;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var hiddenKeys$4 = {};

var has$7 = has$9;
var toIndexedObject$2 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$7(hiddenKeys$3, key) && has$7(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$7(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var anObject$5 = anObject$7;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = DESCRIPTORS$2 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$5(O);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);
  return O;
};

var global$7 = global$c;

var path$1 = global$7;

var path = path$1;
var global$6 = global$c;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$2 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global$6[namespace])
    : path[namespace] && path[namespace][method] || global$6[namespace] && global$6[namespace][method];
};

var getBuiltIn$1 = getBuiltIn$2;

var html$1 = getBuiltIn$1('document', 'documentElement');

var shared = shared$2.exports;
var uid = uid$2;

var keys = shared('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var anObject$4 = anObject$7;
var defineProperties = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$4(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var wellKnownSymbol$4 = wellKnownSymbol$5;
var create$1 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$4('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$1.inspectSource != 'function') {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$5 = global$c;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$5.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$1(WeakMap$1));

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$4 = global$c;
var isObject$1 = isObject$5;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$7;
var objectHas = has$9;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var WeakMap = global$4.WeakMap;
var set, get, has$6;

var enforce = function (it) {
  return has$6(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$6 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$6 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$6,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var DESCRIPTORS$1 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;
var toIndexedObject$1 = toIndexedObject$4;
var toPrimitive = toPrimitive$2;
var has$5 = has$9;
var IE8_DOM_DEFINE = ie8DomDefine;

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$1 ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$5(O, P)) return createPropertyDescriptor$1(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var redefine$3 = {exports: {}};

var global$3 = global$c;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$7;
var has$4 = has$9;
var setGlobal$1 = setGlobal$3;
var inspectSource = inspectSource$2;
var InternalStateModule$1 = internalState;

var getInternalState$1 = InternalStateModule$1.get;
var enforceInternalState = InternalStateModule$1.enforce;
var TEMPLATE = String(String).split('String');

(redefine$3.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$4(value, 'name')) createNonEnumerableProperty$4(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global$3) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$4(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState$1(this).source || inspectSource(this);
});

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$2;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$3 = anObject$7;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$3(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has$3 = has$9;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$3(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$3 = fails$8;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$3(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$2 = global$c;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$7;
var redefine$2 = redefine$3.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$2;
  } else if (STATIC) {
    target = global$2[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$2[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$2(target, key, sourceProperty, options);
  }
};

var requireObjectCoercible = requireObjectCoercible$2;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var fails$2 = fails$8;

var correctPrototypeGetter = !fails$2(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$2 = has$9;
var toObject$1 = toObject$2;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject$1(O);
  if (has$2(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var getPrototypeOf$1 = objectGetPrototypeOf;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$7;
var has$1 = has$9;
var wellKnownSymbol$3 = wellKnownSymbol$5;

var ITERATOR$2 = wellKnownSymbol$3('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

var returnThis$2 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype$2 == undefined) IteratorPrototype$2 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!has$1(IteratorPrototype$2, ITERATOR$2)) {
  createNonEnumerableProperty$2(IteratorPrototype$2, ITERATOR$2, returnThis$2);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var has = has$9;
var wellKnownSymbol$2 = wellKnownSymbol$5;

var TO_STRING_TAG$1 = wellKnownSymbol$2('toStringTag');

var setToStringTag$2 = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG$1)) {
    defineProperty$1(it, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isObject = isObject$5;

var aPossiblePrototype$1 = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

var anObject$2 = anObject$7;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$2(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$1 = _export;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$7;
var redefine$1 = redefine$3.exports;
var wellKnownSymbol$1 = wellKnownSymbol$5;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$1('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') {
          createNonEnumerableProperty$1(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty$1(IterablePrototype, ITERATOR$1, defaultIterator);
  }
  Iterators$1[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$1({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var toIndexedObject = toIndexedObject$4;
var addToUnscopables = addToUnscopables$1;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineIterator = defineIterator$1;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

var DESCRIPTORS = descriptors;
var fails$1 = fails$8;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$2;
var IndexedObject = indexedObject;

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails$1(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

var anObject$1 = anObject$7;

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var redefine = redefine$3.exports;
var anObject = anObject$7;
var fails = fails$8;
var flags = regexpFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var global$1 = global$c;
var DOMIterables = domIterables;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$7;
var wellKnownSymbol = wellKnownSymbol$5;

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global$1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}

const defaultColors = {
  primary: {
    150: '',
    140: '#001A41',
    130: '#002E68',
    120: '#004492',
    110: '#005BBF',
    100: '#2172DC',
    90: '#4A8FFB',
    80: '#7AABFF',
    70: '#AAC7FF',
    60: '#D6E2FF',
    50: '#EBF0FF',
    40: '#FDFBFF',
    30: '',
    20: '',
    10: ''
  },
  secondary: {
    150: '',
    140: '',
    130: '#131C2C',
    120: '#283041',
    110: '#3F4759',
    100: '#565E71',
    90: '#6F778A',
    80: '#8991A5',
    70: '#A3ABC0',
    60: '#BEC6DC',
    50: '#DAE2F9',
    40: '#EBF0FF',
    30: '#FDFBFF',
    20: '',
    10: ''
  },
  tertiary: {
    150: '',
    130: '',
    140: '',
    120: '#22005D',
    110: '#3B0092',
    100: '#5B31B2',
    90: '#6C44C4',
    80: '#855FDE',
    70: '#9F79FA',
    60: '#B99AFF',
    50: '#D2BCFF',
    40: '#EBDDFF',
    30: '#F7EDFF',
    20: '#FFFBFD',
    10: ''
  },
  neutral: {
    150: '',
    140: '',
    130: '#1B1B1D',
    120: '#2D3037',
    110: '#44474F',
    100: '#5C5E66',
    90: '#74777F',
    80: '#8E9099',
    70: '#A9ABB4',
    60: '#C4C6D0',
    50: '#E0E2EC',
    40: '#EFF0FA',
    30: '#FDFBFF',
    20: '',
    10: ''
  },
  grey: {
    150: '',
    140: '',
    130: '#1B1B1D',
    120: '#2F3034',
    110: '#46474A',
    100: '#5E5E61',
    90: '#77777A',
    80: '#909094',
    70: '#ACABAF',
    60: '#C7C6CA',
    50: '#E3E2E6',
    40: '#F2F0F4',
    30: '#FDFBFF',
    20: '',
    10: ''
  },
  warning: {
    150: '#2A1700',
    140: '#472A00',
    130: '#653E00',
    120: '#855300',
    110: '#A76A00',
    100: '#C78800',
    90: '#E49C35',
    80: '#FFB957',
    70: '#FFDDB4',
    60: '#FFEEDB',
    50: '#FCFCFC',
    40: '',
    30: '',
    20: '',
    10: ''
  },
  success: {
    150: '#002116',
    140: '#003827',
    130: '#00513A',
    120: '#006C4F',
    110: '#008864',
    100: '#109B75',
    90: '#00C291',
    80: '#35DFAC',
    70: '#5CFCC7',
    60: '#B8FFE1',
    50: '#F1FFF7',
    40: '',
    30: '',
    20: '',
    10: ''
  },
  info: {
    150: '#002530',
    140: '#02526A',
    130: '#02607D',
    120: '#037193',
    110: '#0385AD',
    100: '#049BCB',
    90: '#20C8FB',
    80: '#58D5FC',
    70: '#82E0FD',
    60: '#A1E8FD',
    50: '#D0F3FF',
    40: '',
    30: '',
    20: '',
    10: ''
  },
  danger: {
    140: '#400012',
    130: '#670022',
    120: '#910033',
    110: '#B71949',
    100: '#E43861',
    90: '#FD5279',
    80: '#FF879D',
    70: '#FFB2BE',
    60: '#FFDADF',
    50: '#FFEDEF',
    40: '#FCFCFC',
    150: '',
    30: '',
    20: '',
    10: ''
  },
  error: {
    140: '#410001',
    130: '#680003',
    120: '#930006',
    110: '#BA1B1B',
    100: '#F03C3C',
    90: '#FF5449',
    80: '#FF897A',
    70: '#FFB4A9',
    60: '#FFDAD4',
    50: '#FFEDE9',
    150: '',
    40: '',
    30: '',
    20: '',
    10: ''
  },
  white: '#FFFFFF',
  black: '#000000',
  brandGray: '#AAB3B7',
  brandPurple: '#A421F9',
  transparent: 'rgba(0,0,0,0)',
  overlay: 'rgba(18, 18, 20, 0.75)',
  blackAlpha: {
    900: 'rgba(0, 0, 0, 0.92)',
    800: 'rgba(0, 0, 0, 0.8)',
    700: 'rgba(0, 0, 0, 0.64)',
    600: 'rgba(0, 0, 0, 0.48)',
    500: 'rgba(0, 0, 0, 0.36)',
    400: 'rgba(0, 0, 0, 0.24)',
    300: 'rgba(0, 0, 0, 0.16)',
    200: 'rgba(0, 0, 0, 0.08)',
    100: 'rgba(0, 0, 0, 0.06)',
    50: 'rgba(0, 0, 0, 0.04)'
  },
  whiteAlpha: {
    900: 'rgba(255,255,255, 0.92)',
    800: 'rgba(255,255,255, 0.8)',
    700: 'rgba(255,255,255, 0.64)',
    600: 'rgba(255,255,255, 0.48)',
    500: 'rgba(255,255,255, 0.36)',
    400: 'rgba(255,255,255, 0.24)',
    300: 'rgba(255,255,255, 0.16)',
    200: 'rgba(255,255,255, 0.08)',
    100: 'rgba(255,255,255, 0.06)',
    50: 'rgba(255,255,255, 0.04)'
  }
};

const {
  tertiary,
  transparent,
  white
} = defaultColors;
const defaultDecorative = {
  glass: {
    background: `linear-gradient(180deg, ${tertiary[40]} 0%, ${transparent} 100%)`,
    backdropFilter: 'blur(5px)'
  },
  glassVariant: {
    background: `linear-gradient(180deg, ${tertiary[50]} 0%, ${tertiary[30]} 100%)`,
    backdropFilter: 'none'
  },
  glassOutline: {
    background: `linear-gradient(159deg, ${tertiary[120]} 11.3%, ${tertiary[40]} 70.96%, ${white} 88.7%)`,
    backdropFilter: 'none'
  },
  decoGradientBackground: {
    background: `linear-gradient(180deg, ${tertiary[110]} 35.42%, #430099 52.08%, ${tertiary[120]} 100%)`,
    backdropFilter: 'none'
  }
};

const defaultSpace = {
  0: 0,
  2: 2,
  4: 4,
  6: 6,
  8: 8,
  12: 12,
  16: 16,
  24: 24,
  32: 32,
  40: 40,
  48: 48,
  64: 64,
  80: 80,
  96: 96,
  120: 120,
  160: 160
};
const defaultSizes = Object.assign(Object.assign({}, defaultSpace), {
  container: {
    mobile: 320,
    tablet: 768,
    desktop: 960,
    desktopXl: 1200,
    desktop2xl: 1530,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280
  }
});

const defaultShadows = {
  0: '0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(0, 0, 0, 0)',
  1: '0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
  2: '0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
  3: '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)',
  4: '0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)',
  none: '0px 0px 0px rgba(0, 0, 0, 0)',
  base: '0px 1px 2px 0px rgba(19, 28, 44, 0.06), 0px 1px 3px 0px rgba(19, 28, 44, 0.10)',
  xs: '0px 0px 0px 1px rgba(19, 28, 44, 0.05)',
  sm: '0px 1px 2px 0px rgba(19, 28, 44, 0.05)',
  md: '0px 2px 4px -1px rgba(19, 28, 44, 0.06), 0px 4px 6px -1px rgba(19, 28, 44, 0.10)',
  lg: '0px 4px 6px -2px rgba(19, 28, 44, 0.05), 0px 10px 15px -3px rgba(19, 28, 44, 0.10)',
  xl: '0px 20px 25px -5px rgba(19, 28, 44, 0.10), 0px 10px 10px -5px rgba(19, 28, 44, 0.04)',
  '2xl': '0px 25px 50px -12px rgba(19, 28, 44, 0.25)',
  '2xl-reverse': '0 -3px 50px -12px rgba(19, 28, 44, 0.25)',
  'dark-lg': '0px 0px 0px 1px rgba(19, 28, 44, 0.10), 0px 0px 10px 0px rgba(19, 28, 44, 0.20), 0px 15px 40px 0px rgba(19, 28, 44, 0.40)',
  outline: '0px 0px 0px 3px rgba(66, 153, 225, 0.60)',
  inner: '0px 2px 4px 0px rgba(19, 28, 44, 0.06) inset'
};

const defaultBorderRadius = {
  0: 0,
  2: 2,
  4: 4,
  6: 6,
  8: 8,
  12: 12,
  16: 16,
  full: 50
};

const defaultBreakpoints = {
  base: 0,
  sm: 480,
  md: 768,
  lg: 992,
  xl: 1280,
  '2xl': 1536
};

const typography = {
  fonts: {
    display: 'Red Hat Display, sans-serif',
    body: 'Inter, sans-serif'
  },
  fontSizes: {
    '4xs': 10,
    '3xs': 12,
    '3.5xs': 13,
    '2xs': 14,
    xs: 16,
    sm: 18,
    md: 20,
    xm: 22,
    '2xm': 24,
    lg: 28,
    xl: 32,
    '2xl': 36,
    '3xl': 40,
    '4xl': 45,
    '5xl': 57 // '3.5625rem',
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    semi: 600,
    bold: 700
  },
  lineHeights: {
    1: 15,
    2: 16,
    3: 20,
    4: 22,
    5: 24,
    6: 28,
    7: 30,
    8: 32,
    9: 36,
    10: 40,
    11: 44,
    12: 50,
    13: 52,
    14: 75 // '4.687rem',
  },
  letterSpacings: {
    '2xs': 0.15,
    xs: 0.1,
    sm: 0.25,
    md: 0.4,
    lg: 0.5,
    xl: 1.2 // '0.075rem',
  },
  textTransform: {
    upper: 'uppercase'
  },
  textDecoration: {
    under: 'underline'
  }
};

const defaultTextStyles = {
  displayLg: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['5xl'],
    lineHeight: typography.lineHeights[14]
  },
  displayMd: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['4xl'],
    lineHeight: typography.lineHeights[13]
  },
  displaySm: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['2xl'],
    lineHeight: typography.lineHeights[11]
  },
  h1: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['3xl'],
    lineHeight: typography.lineHeights[12]
  },
  h2: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes.xl,
    lineHeight: typography.lineHeights[10]
  },
  h2Bold: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes.xl,
    lineHeight: typography.lineHeights[10]
  },
  h3: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes.lg,
    lineHeight: typography.lineHeights[9]
  },
  h4: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['2xm'],
    lineHeight: typography.lineHeights[8]
  },
  h4Bold: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['2xm'],
    lineHeight: typography.lineHeights[8]
  },
  h5: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.medium,
    fontSize: typography.fontSizes.md,
    lineHeight: typography.lineHeights[7]
  },
  h5Bold: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes.md,
    lineHeight: typography.lineHeights[7]
  },
  h6: {
    fontFamily: typography.fonts.display,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes.sm,
    lineHeight: typography.lineHeights[4]
  },
  titleXl: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.medium,
    fontSize: typography.fontSizes.xm,
    lineHeight: typography.lineHeights[6]
  },
  titleLg: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.medium,
    fontSize: typography.fontSizes.sm,
    lineHeight: typography.lineHeights[5]
  },
  titleMd: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.medium,
    fontSize: typography.fontSizes.xs,
    lineHeight: typography.lineHeights[5],
    letterSpacing: typography.letterSpacings.xs
  },
  titleMdBold: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes.xs,
    lineHeight: typography.lineHeights[5],
    letterSpacing: typography.letterSpacings.xs
  },
  titleSm: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['2xs'],
    lineHeight: typography.lineHeights[3]
  },
  titleSmBold: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['2xs'],
    lineHeight: typography.lineHeights[3]
  },
  bodyLg: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes.xs,
    lineHeight: typography.lineHeights[4]
  },
  bodyMd: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['2xs'],
    lineHeight: typography.lineHeights[3],
    letterSpacing: typography.letterSpacings.sm
  },
  bodyMdSemi: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.semi,
    fontSize: typography.fontSizes['2xs'],
    lineHeight: typography.lineHeights[3],
    letterSpacing: typography.letterSpacings.sm
  },
  bodySm: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['3xs'],
    lineHeight: typography.lineHeights[2],
    letterSpacing: typography.letterSpacings.md
  },
  bodySmSemi: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.semi,
    fontSize: typography.fontSizes['3xs'],
    lineHeight: typography.lineHeights[2],
    letterSpacing: typography.letterSpacings.md
  },
  labelXl: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['xs'],
    lineHeight: typography.lineHeights[3],
    letterSpacing: typography.letterSpacings.xs
  },
  labelLg: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['2xs'],
    lineHeight: typography.lineHeights[3],
    letterSpacing: typography.letterSpacings.xs
  },
  labelLgSemi: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.semi,
    fontSize: typography.fontSizes['2xs'],
    lineHeight: typography.lineHeights[3],
    letterSpacing: typography.letterSpacings.xs
  },
  labelLgBold: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['2xs'],
    lineHeight: typography.lineHeights[3],
    letterSpacing: typography.letterSpacings.xs
  },
  labelLgBoldUnderline: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['2xs'],
    lineHeight: typography.lineHeights[3],
    letterSpacing: typography.letterSpacings.xs,
    textDecoration: typography.textDecoration.under
  },
  labelMdUnderline: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['3.5xs'],
    lineHeight: typography.lineHeights[2],
    letterSpacing: typography.letterSpacings.lg,
    textDecoration: typography.textDecoration.under
  },
  labelMdSemi: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.semi,
    fontSize: typography.fontSizes['3.5xs'],
    lineHeight: typography.lineHeights[2],
    letterSpacing: typography.letterSpacings.lg
  },
  labelMd: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSizes['3.5xs'],
    lineHeight: typography.lineHeights[2],
    letterSpacing: typography.letterSpacings.lg
  },
  labelMdBold: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['3.5xs'],
    lineHeight: typography.lineHeights[2],
    letterSpacing: typography.letterSpacings.xs
  },
  labelMdBoldUnderline: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['3.5xs'],
    lineHeight: typography.lineHeights[2],
    letterSpacing: typography.letterSpacings.xs,
    textDecoration: typography.textDecoration.under
  },
  labelSm: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.medium,
    fontSize: typography.fontSizes['3xs'],
    lineHeight: typography.lineHeights[1],
    letterSpacing: typography.letterSpacings.xs
  },
  labelSmBold: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['3xs'],
    lineHeight: typography.lineHeights[1],
    letterSpacing: typography.letterSpacings.xs
  },
  labelSmBoldUnderline: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['3xs'],
    lineHeight: typography.lineHeights[1],
    letterSpacing: typography.letterSpacings.xs,
    textDecoration: typography.textDecoration.under
  },
  labelXs: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.medium,
    fontSize: typography.fontSizes['4xs'],
    lineHeight: typography.lineHeights[1],
    letterSpacing: typography.letterSpacings.xs
  },
  labelXsBold: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['4xs'],
    lineHeight: typography.lineHeights[1],
    letterSpacing: typography.letterSpacings.xs
  },
  labelXsBoldUnderline: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSizes['4xs'],
    lineHeight: typography.lineHeights[1],
    letterSpacing: typography.letterSpacings.xs,
    textDecoration: typography.textDecoration.under
  },
  overlineLg: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.semi,
    fontSize: typography.fontSizes['3xs'],
    textTransform: typography.textTransform.upper,
    letterSpacing: typography.letterSpacings.xl
  },
  overlineSm: {
    fontFamily: typography.fonts.body,
    fontWeight: typography.fontWeights.semi,
    fontSize: typography.fontSizes['4xs'],
    textTransform: typography.textTransform.upper,
    letterSpacing: typography.letterSpacings.xl
  }
};

const themeDefault = Object.assign({
  styles: {
    // TODO: Global Styles
    global: {
      body: {
        fontSize: typography.fontSizes.xs,
        fontWeight: typography.fontWeights.regular,
        fontFamily: typography.fonts.body,
        color: defaultColors.grey[120],
        backgroundColor: defaultColors.white
      },
      a: {
        color: defaultColors.tertiary[80],
        _hover: {
          color: defaultColors.tertiary[110]
        }
      },
      p: {
        fontVariantNumeric: 'normal'
      }
    }
  },
  colors: defaultColors,
  layerStyles: defaultDecorative,
  space: defaultSpace,
  sizes: defaultSizes,
  shadows: defaultShadows,
  radii: defaultBorderRadius,
  breakpoints: defaultBreakpoints,
  textStyles: defaultTextStyles
}, typography);

// ----------------------------------------------------------------
// Hex String -> RGB String: rgb(r,g,b)
// ----------------------------------------------------------------
const hexToRGB = h => {
  let r = '0',
    g = '0',
    b = '0';
  // 3 digits
  if (h.length == 4) {
    r = '0x' + h[1] + h[1];
    g = '0x' + h[2] + h[2];
    b = '0x' + h[3] + h[3];
    // 6 digits
  } else if (h.length == 7) {
    r = '0x' + h[1] + h[2];
    g = '0x' + h[3] + h[4];
    b = '0x' + h[5] + h[6];
  }
  return 'rgb(' + +r + ', ' + +g + ', ' + +b + ')';
};
// ----------------------------------------------------------------
// Integrer -> String + 'REM'
// ----------------------------------------------------------------
const numToRem = int => {
  return (int / 16).toString() + 'rem';
};

// Breakpoints
const breakpointsToRem = {
  base: numToRem(themeDefault.breakpoints.base),
  sm: numToRem(themeDefault.breakpoints.sm),
  md: numToRem(themeDefault.breakpoints.md),
  lg: numToRem(themeDefault.breakpoints.lg),
  xl: numToRem(themeDefault.breakpoints.xl),
  '2xl': numToRem(themeDefault.breakpoints['2xl'])
};
// Spacing
const spaceToRem = {
  0: numToRem(themeDefault.space[0]),
  2: numToRem(themeDefault.space[2]),
  4: numToRem(themeDefault.space[4]),
  6: numToRem(themeDefault.space[6]),
  8: numToRem(themeDefault.space[8]),
  12: numToRem(themeDefault.space[12]),
  16: numToRem(themeDefault.space[16]),
  24: numToRem(themeDefault.space[24]),
  32: numToRem(themeDefault.space[32]),
  40: numToRem(themeDefault.space[40]),
  48: numToRem(themeDefault.space[48]),
  64: numToRem(themeDefault.space[64]),
  80: numToRem(themeDefault.space[80]),
  96: numToRem(themeDefault.space[96]),
  120: numToRem(themeDefault.space[120]),
  160: numToRem(themeDefault.space[160])
};
// Sizes
const sizesToRem = Object.assign(Object.assign({}, spaceToRem), {
  container: {
    mobile: numToRem(themeDefault.sizes.container.mobile),
    tablet: numToRem(themeDefault.sizes.container.tablet),
    desktop: numToRem(themeDefault.sizes.container.desktop),
    desktopXl: numToRem(1200),
    desktop2xl: numToRem(1530),
    sm: numToRem(640),
    md: numToRem(768),
    lg: numToRem(1024),
    xl: numToRem(1280)
  }
});
// Border Radius
const radiiToRem = {
  0: numToRem(themeDefault.radii[0]),
  2: numToRem(themeDefault.radii[2]),
  4: numToRem(themeDefault.radii[4]),
  6: numToRem(themeDefault.radii[6]),
  8: numToRem(themeDefault.radii[8]),
  12: numToRem(themeDefault.radii[12]),
  16: numToRem(themeDefault.radii[16]),
  full: themeDefault.radii.full.toString() + '%'
};
// textStyles | Convert to string
const convertTextStyles = obj => {
  Object.entries(obj).forEach(([key1, value1]) => {
    Object.entries(value1).forEach(([key2, value2]) => {
      if (key2 === 'lineHeight' || key2 === 'letterSpacing' || key2 === 'fontSize') {
        obj[key1][key2] = numToRem(value2);
      }
    });
  });
  return obj;
};
const textStylesCopy = JSON.parse(JSON.stringify(themeDefault.textStyles));
const textStylesToRem = convertTextStyles(textStylesCopy);
// Border Radius
const typographyToRem = {
  fonts: themeDefault.fonts,
  fontSizes: {
    '4xs': numToRem(themeDefault.fontSizes['4xs']),
    '3xs': numToRem(themeDefault.fontSizes['3xs']),
    '3.5xs': numToRem(themeDefault.fontSizes['3.5xs']),
    '2xs': numToRem(themeDefault.fontSizes['2xs']),
    xs: numToRem(themeDefault.fontSizes.xs),
    sm: numToRem(themeDefault.fontSizes.sm),
    md: numToRem(themeDefault.fontSizes.md),
    xm: numToRem(themeDefault.fontSizes.xm),
    '2xm': numToRem(themeDefault.fontSizes['2xm']),
    lg: numToRem(themeDefault.fontSizes.lg),
    xl: numToRem(themeDefault.fontSizes.xl),
    '2xl': numToRem(themeDefault.fontSizes['2xl']),
    '3xl': numToRem(themeDefault.fontSizes['3xl']),
    '4xl': numToRem(themeDefault.fontSizes['4xl']),
    '5xl': numToRem(themeDefault.fontSizes['5xl']) // '3.5625rem',
  },
  fontWeights: themeDefault.fontWeights,
  lineHeights: {
    1: numToRem(themeDefault.lineHeights[1]),
    2: numToRem(themeDefault.lineHeights[2]),
    3: numToRem(themeDefault.lineHeights[3]),
    4: numToRem(themeDefault.lineHeights[4]),
    5: numToRem(themeDefault.lineHeights[5]),
    6: numToRem(themeDefault.lineHeights[6]),
    7: numToRem(themeDefault.lineHeights[7]),
    8: numToRem(themeDefault.lineHeights[8]),
    9: numToRem(themeDefault.lineHeights[9]),
    10: numToRem(themeDefault.lineHeights[10]),
    11: numToRem(themeDefault.lineHeights[11]),
    12: numToRem(themeDefault.lineHeights[12]),
    13: numToRem(themeDefault.lineHeights[13]),
    14: numToRem(themeDefault.lineHeights[14]) // '4.687rem',
  },
  letterSpacings: {
    '2xs': numToRem(themeDefault.letterSpacings['2xs']),
    xs: numToRem(themeDefault.letterSpacings.xs),
    sm: numToRem(themeDefault.letterSpacings.sm),
    md: numToRem(themeDefault.letterSpacings.md),
    lg: numToRem(themeDefault.letterSpacings.lg),
    xl: numToRem(themeDefault.letterSpacings.xl) // '0.075rem',
  },
  textTransform: themeDefault.textTransform,
  textDecoration: themeDefault.textDecoration
};
const themeChakra = Object.assign(Object.assign({
  styles: {
    // TODO: Global Styles
    global: {
      body: {
        fontSize: typographyToRem.fontSizes.xs,
        fontWeight: typographyToRem.fontWeights.regular,
        fontFamily: typographyToRem.fonts.body,
        color: themeDefault.colors.grey[120],
        backgroundColor: themeDefault.colors.white
      },
      a: {
        color: themeDefault.colors.tertiary[80],
        _hover: {
          color: themeDefault.colors.tertiary[110]
        }
      },
      p: {
        fontVariantNumeric: 'normal'
      }
    }
  }
}, typographyToRem), {
  colors: themeDefault.colors,
  radii: radiiToRem,
  space: spaceToRem,
  sizes: sizesToRem,
  shadows: themeDefault.shadows,
  textStyles: textStylesToRem,
  layerStyles: themeDefault.layerStyles,
  breakpoints: breakpointsToRem
});

exports.defaultColors = defaultColors;
exports.hexToRGB = hexToRGB;
exports.numToRem = numToRem;
exports.themeChakra = themeChakra;
exports.themeDefault = themeDefault;
